import React, { useMemo } from "react";
import { FilterContainer } from "./index.styled";
import CustomSelect, { type SelectOption } from "../../CustomSelect";
import { getPeriodIcon, getPeriodAltText } from "../utils/iconHelpers";

export type FilterPeriod = "all" | "day" | "week";

interface CampaignSummaryFilterProps {
  activeFilter: FilterPeriod | undefined;
  selectedMonth?: number | undefined;
  onFilterChange: (filter: FilterPeriod) => void;
  onMonthChange?: (month: number) => void;
}

const CampaignSummaryFilter: React.FC<CampaignSummaryFilterProps> = ({
  activeFilter,
  selectedMonth,
  onFilterChange,
  onMonthChange,
}) => {
  const filters: { key: FilterPeriod; label: string; useIcon: boolean }[] = [
    { key: "all", label: "הכל", useIcon: false },
    { key: "day", label: "היום", useIcon: true },
    { key: "week", label: "השבוע", useIcon: true },
  ];

  const monthNames = [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר",
  ];

  const monthOptions: SelectOption[] = useMemo(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-11 (JavaScript month indexing)

    // Only include months that have already passed this year (including current month)
    return monthNames
      .map((monthName, index) => ({
        value: index + 1, // 1-12 for consistency with existing logic
        label: monthName,
        monthIndex: index, // 0-11 for comparison
      }))
      .filter((month) => month.monthIndex <= currentMonth)
      .map(({ value, label }) => ({ value, label })); // Remove monthIndex from final result
  }, [monthNames]);

  return (
    <FilterContainer>
      {filters.map((filter, index) => (
        <div
          key={filter.key}
          className={`filter-item ${index === 0 ? "first-item" : ""}`}
        >
          {filter.useIcon && (
            <img
              src={getPeriodIcon(filter.key)}
              alt={getPeriodAltText(filter.key)}
              width="16"
              height="16"
              className="filter-icon"
            />
          )}
          <button
            className={`filter-button ${
              activeFilter === filter.key ? "active" : ""
            }`}
            onClick={() => onFilterChange(filter.key)}
          >
            {filter.label}
          </button>
        </div>
      ))}

      <div className="filter-item">
        <img
          src={getPeriodIcon("year")}
          alt={getPeriodAltText("year")}
          width="16"
          height="16"
          className="filter-icon"
        />
        <CustomSelect
          options={monthOptions}
          value={selectedMonth}
          onChange={(value) => onMonthChange?.(value as number)}
          placeholder="בחר חודש"
        />
      </div>
    </FilterContainer>
  );
};

export default CampaignSummaryFilter;
